import { PermissionEnum } from '@Application/Security/Roles';
import PageContainer from '@Guidelines/Layout/PageContainer';
import PageHeader from '@Guidelines/Layout/PageHeader';
import StaffMembersConfirmationDialogs from '@UI/Pages/Agencies/StaffMembers/ConfirmationDialogs/StaffMembersConfirmationDialogs';
import StaffMembersContent from '@UI/Pages/Agencies/StaffMembers/StaffMembersContent';
import StaffMembersNotifications from '@UI/Pages/Agencies/StaffMembers/StaffMembersNotifications';
import StaffMemberSidebar from '@UI/Pages/Agencies/StaffMembers/Sidebars/StaffMemberSidebar';
import { openStaffMemberSidebar } from '@UI/Pages/Agencies/StaffMembers/Signals/staffMemberSidebarSignal';
import useCurrentOrganization from '@UI/Providers/CurrentOrganizationProvider/useCurrentOrganization';
import WithPermission from '@UI/Providers/PermissionProvider/WithPermission';
import { Plus } from 'lucide-react';
import * as React from 'react';
import { Button } from '@verclam/ui-kit';

/**
 * Assembles the page: header, the data-owning `StaffMembersContent`, `StaffMemberSidebar`,
 * `StaffMembersConfirmationDialogs` and notifications, in that visual order. Mono-screen feature: no
 * `{Screen}/` level, no `Shared/` — mirrors `UI/Pages/Agencies/Facilities/`.
 */
const StaffMembersPage: React.FC = () => {
	const { currentOrganization } = useCurrentOrganization();
	const organizationId = currentOrganization?.id ?? null;

	const handleCreateClick = React.useCallback(() => {
		openStaffMemberSidebar(null);
	}, []);

	const eyebrow = currentOrganization !== null ? `STRUCTURE · ${currentOrganization.name}` : 'STRUCTURE';

	return (
		<PageContainer>
			<PageHeader
				eyebrow={eyebrow}
				title="Personnel"
				description="Le personnel de votre structure."
				actions={
					organizationId && (
						<WithPermission permission={PermissionEnum.STAFF_WRITE}>
							<Button
								type="button"
								label="Nouveau membre"
								icon={<Plus size={16} />}
								onClick={handleCreateClick}
							/>
						</WithPermission>
					)
				}
			/>
			<StaffMembersContent />
			<StaffMemberSidebar />
			<StaffMembersConfirmationDialogs />
			<StaffMembersNotifications />
		</PageContainer>
	);
};

export default StaffMembersPage;
